import { css } from 'styled-components';
import globalStyles from 'gatsby-theme-core/src/components/form-elements/global-styles';

export default css`
  ${globalStyles}
  border: 1px solid ${(props) => props.theme.gray2};
  border-radius: .25rem;
`;
